import { render, staticRenderFns } from "./PrkNewCourseModal.vue?vue&type=template&id=3fa2c9cd&"
import script from "./PrkNewCourseModal.vue?vue&type=script&lang=js&"
export * from "./PrkNewCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports